import React , {useState , useEffect} from 'react';
import Rightel from '../../style/images/receptions/Rightel.png';
import ReceptionInfo from './ReceptionInfo';
import ellipse from '../../style/images/Group-5.png';
import Guide from "../Guide";
import Confirmation from "./Confirmation";
import {auth} from '../../Actions/index';
import {connect} from 'trim-redux';
import Farhangi from "./Farhangi";
import check from '../../style/images/check.png';
import Select from 'react-select';
import {toNum} from '../../utils';
import Failed from "./Failed";
import {suppInfo, verifyToken} from "../../Actions";
import $ from 'jquery';
import BalanceStatus from "./BalanceStatus";


const Login = ({paymentToken , loading , failed  , step , customerAccessToken
                   ,userNotFound ,callBackUrl,sponsors , terminalNum ,
                   noContract , smsFailed , minCreditError , AuthGeneralErr
                   , buttonLoading , buttonDisabled , isFailed ,sponsorsOptions}) => {
    const [mobileNeed  , setMobileField] = useState(true);
    const [mobileNumber , setMobileNumber] = useState('');
    const [codeMelli , setCodeMelli] = useState("");
    const [err , setErr] = useState(false);
    const colourStyles = {
        option: (styles,{ data, isDisabled, isFocused, isSelected, }) => {
            return {
                ...styles,
                borderBottom: '1px solid #eee',
                display: "flex",
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: isDisabled
                    ? null
                    : isSelected
                        ? "#fff"
                        : isFocused
                            ? "#f9f9f9"
                            : null,
                color: isDisabled
                    ? '#ccc'
                    : isSelected
                        ? "#2729d2"
                        : "#093b7c",
                cursor: isDisabled ? 'not-allowed' : 'default',
                
                ':active': {
                    color: !isDisabled && (isSelected ? '#2729d2' : "#093b7c"),
                    
                },
                ':after': {
                    content:  isSelected ?`url(${check})`: '',
                    display: 'block',
                    marginRight: 8,
                }
            };
        },
        control: styles => ({ ...styles, backgroundColor: 'white' }),
    };
    
    function onChangeHandler(e) {
        setMobileField(true);
    }
    function getCode() {
     // let melliErr = melliCode_check(codeMelli);
        if(mobileNumber.length !== 11)
            setErr(true);
        else{
            setErr(false);
           // setCodeMelliErr(false);
            auth(mobileNumber , paymentToken , false)
        }
       
    }
    function handleMobileValidation() {
        if (mobileNumber === "")
            setErr(false);
        else if(!mobileNumber.startsWith("09"))
            setErr(true);
        else
            setErr(false)
      
    }
    function handleMobileNumber(e) {
        setMobileNumber(toNum(e.target.value))
        
    }
    function handleNationalCode(e) {
        setCodeMelli(toNum(e.target.value));
    }
    function focusOnSelect() {
        $('.css-1wa3eu0-placeholder').css("top" , "39%")
    }
    return (
        loading ?
            <div className='loadingWrap'>
                <p>لطفا شکیبا باشید</p>
                <div className="spinner" style={{margin: "auto"}}>
                    <div className="bounce1" style={{width: 6 , height: 6 , margin: "0 1px" , background: "#093b7c"}}></div>
                    <div className="bounce2" style={{width: 6 , height: 6 , margin: "0 1px" , background: "#093b7c"}}></div>
                    <div className="bounce3" style={{width: 6 , height: 6 , margin: "0 1px" , background: "#093b7c"}}></div>
                </div>
            </div>
            :
            isFailed ? <Failed/>
                :
               <div>
                   <div className='container portal-container'>
                       <div className='row login-con' style={{justifyContent: 'center'}}>
                           <div>
                               <ReceptionInfo top={0} receptionLogo={Rightel} interest={false} little={true} pos='relative'/>
                               {/*<div className='align-vertical  marginTop'>*/}
                               {/*<span className='havent-register'>ثبت نام نکرده اید؟</span>*/}
                               {/*<span className='register-guide'>راهنمای ثبت نام در سازمان ها</span>*/}
                               {/*</div>*/}
                           </div>
                           <div className='sepratorFooterAndContent' style={{minHeight: 500 , display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                               <div className='payment' style={{padding: '18px 20px' , minHeight: 258}}>
                                   <div className='payment-title'>
                        <span>
                          <img src={ellipse}/>
                        </span>
                                       {step === 3 ?<h3 style={{marginRight: 10}}>تایید مدارک و تکمیل اطلاعات</h3> : step === 4 ? <h3 style={{marginRight: 10}}>اطلاعات اعتباری استعلام شده</h3> :  <h3 style={{marginRight: 10}}>استعلام اعتبار</h3> }
                                   </div>
                                   {
                                       step ===  1 ? (
                                               <div style={{marginTop: 25}}>
                                                   {/* <div className='installment-info  vertical-layout'>
                                                       <section>
                                                           <span className='info-titles inputs-label' > مرجع اعتبار دهنده</span>
                                                       </section>
                                                       <section className='inputs-wrapper'>
                                                           <div className='input-group mb-3'>
                                                               <Select options={sponsorsOptions}
                                                                       placeholder="انتخاب کنید"
                                                                       styles={colourStyles}
                                                                       onChange={onChangeHandler}
                                                                       isRtl={true}
                                                                       onFocus={focusOnSelect}
                                                               />
                                                           </div>
                                                       </section>
                                                   </div> */}
                                                   {
                                                       mobileNeed ?
                                                           (<div>
                                                               <div className='installment-info reception-info vertical-layout'>
                                                                   <section style={{marginRight: 5}}>
                                                                       <span className='info-titles inputs-label'> شناسه کیپا</span>
                                                                   </section>
                                                                   <section className='inputs-wrapper'>
                                                                       <div className='' style={{textAlign: 'right'}}>
                                                                           <input type='text' onKeyUp={handleMobileValidation}  placeholder='09---------' onChange={handleMobileNumber}
                                                                                  maxLength={11}  className={err ? "form-control errorBorder" :"form-control" } style={{padding: '12px', textAlign: 'left' , marginTop: 6}}/>
                                                                           <span className={err ? "errorMsg display-block" : 'display-none'}>شماره موبایل وارد شده نادرست است</span>
                                                                           <span className='inputDesc display-block'>شناسه کیپا شماره موبایل ثبت نامی در اپلیکیشن کیپا است</span>

                                                                       </div>
                                                                   </section>
                                                                   <div className={userNotFound ? "userNotFound display-block" : "display-none"}>
                                                                       <p>کاربری با مشخصات فوق یافت نشد</p>
                                                                       <ul>
                                                                           <li>
                                                                               در صورتیکه از صحت اطلاعات و ثبت نام خود اطمینان دارید، با پشتیبانی کیپا تماس حاصل فرمائید.
                                                                           </li>
                                                                       </ul>
                                                                   </div>
                                                                   <div className={noContract ? "userNotFound display-block" : "display-none"}>
                                                                       <p>امکان خرید از این فروشگاه برای شما وجود ندارد</p>
                                                                       <ul>
                                                                           <li>
                                                                               به دلیل عدم قرارداد سازمان اعتبار دهنده شما با این فروشگاه، امکان خرید وجود ندارد. در صورت هرگونه سوال، با پشتیبانی کیپا تماس حاصل فرمائید.
                                                                           </li>
                                                                       </ul>
                                                                   </div>
                                                                   <div className={smsFailed ? "userNotFound display-block" : "display-none"}>
                                                                       <p> در ارسال پیامک رمز پویا خطایی رخ داده است</p>
                                                                       <ul>
                                                                           <li>
                                                                               لطفا پس از ده دقیقه مجددا اقدام نمائید و در صورت تکرار خطا، با پشتیبانی کیپا تماس حاصل فرمائید.
                                                                           </li>
                                                                       </ul>
                                                                   </div>
                                                                   <div className={minCreditError ? "userNotFound display-block" : "display-none"}>
                                                                       <p>موجودی اعتبار شما برای خرید از این فروشگاه کافی نیست</p>
                                                                       <ul>
                                                                           <li>
                                                                               در صورت هرگونه سوال، با پشتیبانی کیپا تماس حاصل فرمائید.
                                                                           </li>
                                                                       </ul>
                                                                   </div>
                                                                   <div className={AuthGeneralErr ? "userNotFound display-block" : "display-none"}>
                                                                       <p>در برقراری ارتباط با سوییچ اعتباری کیپا خطایی رخ داده است </p>
                                                                       <ul>
                                                                           <li>
                                                                               لطفا پس از ده دقیقه مجددا اقدام نمائید و در صورت تکرار خطا، با پشتیبانی کیپا تماس حاصل فرمائید.
                                                                           </li>
                                                                       </ul>
                                                                   </div>
                                                               </div>
                                                               {/*<div className='installment-info reception-info vertical-layout'>*/}
                                                               {/*<section style={{marginRight: 5}}>*/}
                                                               {/*<span className='info-titles inputs-label'> کد ملی</span>*/}
                                                               {/*</section>*/}
                                                               {/*<section className='inputs-wrapper'>*/}
                                                               {/*<div className='' style={{textAlign: 'right'}}>*/}
                                                               {/*<input type='text'  placeholder='کدملی 10 رقمی بدون خط تیره' onChange={handleNationalCode}*/}
                                                               {/*maxLength={10}  className={codeMelliErr ? "form-control errorBorder melliCode" :"form-control melliCode" } style={{padding: '12px', textAlign: 'left' , marginTop: 6}}/>*/}
                                                               {/*<span className={codeMelliErr ? "errorMsg display-block" : 'display-none'}>کد ملی وارد شده نادرست است</span>*/}
                                                               {/*</div>*/}
                                                               {/*</section>*/}
                                                               {/*</div>*/}
                        
                                                               <div className='installment-info reception-info vertical-layout'>
                                                                   <section className='inputs-wrapper'>
                                                                       <div className='input-group mb-3'>
                                                                           <button className="big-success-btn" disabled={buttonDisabled} onClick={getCode}>
                                                                               {
                                                                                   buttonLoading ? (
                                                                                       <div className="spinner" style={{margin:  "auto"}}>
                                                                                           <div className="bounce1" style={{width: 6 , height: 6 , margin: "0 1px" , background: "#fff"}}></div>
                                                                                           <div className="bounce2" style={{width: 6 , height: 6 , margin: "0 1px" , background: "#fff"}}></div>
                                                                                           <div className="bounce3" style={{width: 6 , height: 6 , margin: "0 1px" , background: "#fff"}}></div>
                                                                                       </div>) : "دریافت کد تایید"
                                                                               }
                                    
                                                                           </button>
                                                                       </div>
                                                                   </section>
                                                               </div>
                                                           </div>) :
                                                           (<span></span>)
                                                   }
                                               </div>
                                           ) :
                                           step === 3 ? <Farhangi/>
                                               :
                                               step === 4 ? <BalanceStatus/>
                                                   :
                                               (
    
                                                   <div className='installment-info reception-info vertical-layout'>
                                                       <Confirmation mobileNum={mobileNumber}/>
                                                   </div>
                                               )
                                   }
                               </div>
                               <form action={`https://pay.kipaa.ir/${localStorage.terminalNum}`} method="post" name='redirectToSupplier'>
                                   <input name="reciept_number" value="" hidden/>
                                   <input name="payment_token" value={paymentToken} hidden/>
                                   <input name="state" value="103" hidden/>
                                   <input name="msg" value="بازگشت از صفحه ی پرداخت" hidden/>
                                   <button className='backToSupp-btn' type="submit">
                                       بازگشت به صفحه ی پرداخت به پذیرنده
                                   </button>
                               </form>
                           </div>
                       </div>
                   </div>
                   <div className='pre-footer' style={{marginTop: 55}}>
                       <Guide logos={true}/>
                   </div>
                   <div className='pre-footer'>
                       <Guide logos={false}/>
                   </div>
               </div>
        
    )
};
const mstp = state => ({
    paymentToken: state.paymentToken,
    loading: state.loading,
    isFailed: state.isFailed,
    errMessage: state.errMessage,
    step: state.step,
    failed: state.failed,
    customerAccessToken: state.customerAccessToken,
    sponsors: state.sponsors,
    terminalNum: state.terminalNum,
    userNotFound: state.userNotFound,
    callBackUrl: state.callBackUrl,
    noContract: state.noContract,
    smsFailed: state.smsFailed,
    minCreditError: state.minCreditError,
    AuthGeneralErr: state.AuthGeneralErr,
    buttonLoading: state.buttonLoading,
    buttonDisabled: state.buttonDisabled,
    sponsorsOptions: state.sponsorsOptions
});
export default connect (mstp)(Login);
